import { put } from '@redux-saga/core/effects';
import { AxiosError } from 'axios';
import { UNEXPECTED_ERROR } from './constants';
import { toasterBarActions } from './slice';
import logger from '../../../utils/logger';

export function* displayError(error: any) {
  const { data, status, statusText } = error?.response ?? {
    data: {},
    status: 0,
    statusText: '',
  };

  if (status >= 400) {
    logger.error({
      message: `API error occurred (${status})`,
      info: {
        statusCode: status,
        errorMessage:
          data?.developer_message ||
          data?.message ||
          statusText ||
          UNEXPECTED_ERROR,
        url: error.config?.url,
      },
    });
  }

  yield put(
    toasterBarActions.showToast({
      type: 'error',
      message: data?.message || statusText || UNEXPECTED_ERROR,
    }),
  );
}

export function* displaySuccessToaster(msg: string) {
  yield put(
    toasterBarActions.showToast({
      type: 'success',
      message: msg,
    }),
  );
}

export function* displayInfoToaster(msg: string) {
  yield put(
    toasterBarActions.showToast({
      type: 'info',
      message: msg,
    }),
  );
}

export function* displayErrorToaster(msg: string) {
  yield put(
    toasterBarActions.showToast({
      type: 'error',
      message: msg,
    }),
  );
}

export function* displayWarningToaster(msg: string) {
  yield put(
    toasterBarActions.showToast({
      type: 'warning',
      message: msg,
    }),
  );
}
